/**
 * Subcategory tabs for requirement browsing.
 */

import { Tabs } from 'antd';
import { CloudFilled } from '@ant-design/icons';
import { SUBCATEGORY_OPTIONS } from '@/constants/requirements';

interface SubcategoryTabsProps {
  activeKey: string;
  onChange: (key: string) => void;
  /** 有主线新增需求（项目缺失）的 subcategory 集合，用于显示黄云朵 */
  newReqSubcats?: Set<string>;
  /** 当前用户是否有同步权限（负责人/需求修改权限用户）；外部用户为 false */
  canSync?: boolean;
  /** 点击黄云朵回调 */
  onCloudClick?: (subcat: string) => void;
}

const SubcategoryTabs: React.FC<SubcategoryTabsProps> = ({
  activeKey,
  onChange,
  newReqSubcats,
  canSync,
  onCloudClick,
}) => {
  const items = [
    { key: 'overview', label: '总览' },
    ...SUBCATEGORY_OPTIONS.map(({ key, label }) => {
      const sub = key as string;
      const showCloud = !!canSync && !!newReqSubcats?.has(sub);
      return {
        key: sub,
        label: (
          <span>
            {label}
            {showCloud && (
              <CloudFilled
                style={{ color: '#d48806', marginLeft: 6 }}
                onClick={(e) => {
                  e.stopPropagation();
                  onCloudClick?.(sub);
                }}
              />
            )}
          </span>
        ),
      };
    }),
  ];

  return (
    <Tabs
      activeKey={activeKey}
      onChange={onChange}
      items={items}
      type="card"
      className="requirement-tabs"
    />
  );
};

export default SubcategoryTabs;
